import { FeeType } from 'generated/graphql';
import ItemCollector from '../../../Filters/Filters/queries/ItemCollector';

const stringComparator = (a, b) => {
  if (a === b) {
    return 0;
  }
  return a < b ? -1 : 1;
};
const feeTypeComparator =
  (defaultFeeType: FeeType) =>
  (firstFeeType: FeeType, secondFeeType: FeeType) => {
    const feeTypeId = defaultFeeType.id;
    if (firstFeeType.id === feeTypeId) {
      return -1;
    } else if (secondFeeType.id === feeTypeId) {
      return 1;
    }
    if (firstFeeType.name && secondFeeType.name) {
      return stringComparator(firstFeeType.name, secondFeeType.name);
    } else if (!firstFeeType.name && !secondFeeType.name) {
      return stringComparator(
        firstFeeType.paymentMethod,
        secondFeeType.paymentMethod
      );
    } else {
      return !firstFeeType.name ? -1 : 1;
    }
  };

const FeeTypeCollector = (defaultFeeType: FeeType) => {
  const itemCollector = ItemCollector<FeeType>();

  return {
    add(feeType: FeeType) {
      itemCollector.add(feeType);
    },
    build(): FeeType[] {
      return itemCollector.build().sort(feeTypeComparator(defaultFeeType));
    },
  };
};

export default FeeTypeCollector;
